import { ExportColumnData, ExportSectionData } from "./activeMeasuringPointsTypes";

export const exportColumnsMeasuringPoint: Array<ExportColumnData> = [
  {
    label: "Name",
    name: "name",
  },
  {
    label: "Umspannwerk",
    name: "substation",
  },
  {
    label: "Schaltfeld",
    name: "switchgear",
  },
  {
    label: "Spannungsebene",
    name: "voltageLevel",
  },
  {
    label: "Wandlerfaktor Strom",
    name: "currentTransformer",
  },
  {
    label: "Wandlerfaktor Spannung",
    name: "voltageTransformer",
  },
  {
    label: "Breitengrad",
    name: "latitude",
  },
  {
    label: "Längengrad",
    name: "longitude",
  },
  {
    label: "Kommentar",
    name: "comment",
  },
];
export const exportColumnsDevice: Array<ExportColumnData> = [
  {
    label: "Seriennummer",
    name: "deviceSerialNumber",
  },
  {
    label: "Hersteller",
    name: "deviceManufacturer",
  },
  {
    label: "Typ",
    name: "deviceModel",
  },
  {
    label: "Herstellungsjahr",
    name: "deviceProductionYear",
  },
  {
    label: "Firmware",
    name: "deviceFirmware",
  },
  {
    label: "MAC-Adresse",
    name: "deviceMacAddress",
  },
  {
    label: "Inbetriebnahmedatum",
    name: "deviceCommissioningDate",
  },
  {
    label: "Wartungsintervall",
    name: "deviceMaintenanceCycle",
  },
  {
    label: "Zeitsynchronisationsart",
    name: "deviceTimeSynchronisationType",
  },
  {
    label: "IP-Adresse",
    name: "deviceIPAddress",
  },
  {
    label: "Subnetzmaske",
    name: "deviceSubnetMask",
  },
  {
    label: "Kommentar",
    name: "deviceComment",
  },
];
export const exportColumnsRouter: Array<ExportColumnData> = [
  {
    label: "Seriennummer",
    name: "routerSerialNumber",
  },
  {
    label: "Hersteller",
    name: "routerManufacturer",
  },
  {
    label: "Typ",
    name: "routerModel",
  },
  {
    label: "Herstellungsjahr",
    name: "routerProductionYear",
  },
  {
    label: "Firmware",
    name: "routerFirmware",
  },
  {
    label: "MAC-Adresse",
    name: "routerMacAddress",
  },
  {
    label: "Inbetriebnahmedatum",
    name: "routerCommissioningDate",
  },
  {
    label: "Wartungsintervall",
    name: "routerMaintenanceCycle",
  },
  {
    label: "Zeitsynchronisationsart",
    name: "routerTimeSynchronisationType",
  },
  {
    label: "IP-Adresse",
    name: "routerIPAddress",
  },
  {
    label: "Subnetzmaske",
    name: "routerSubnetMask",
  },
  {
    label: "Kommentar",
    name: "routerComment",
  },
];
export const exportSections: Array<ExportSectionData> = [
  {
    label: "Messstelle",
    category: "measuringPoint",
    exportColumns: exportColumnsMeasuringPoint,
  },
  {
    label: "Messgerät",
    category: "device",
    exportColumns: exportColumnsDevice,
  },
  {
    label: "Router",
    category: "router",
    exportColumns: exportColumnsRouter,
  },
];
